/* eslint-disable jsx-a11y/iframe-has-title */
"use client"

import React from 'react'

const Contact = () => {
    return (
        <>
            <section id="location" class="map-banner">
                <div class="container">
                    <div class="row">
                        <h2 class="heading-title">Contact us</h2>
                        <div class="map-top-ic clearfix">
                            <div class="map-top-block">
                                <div class="map-inner-ic">
                                    <i class="icofont icofont-location-pin"></i>
                                </div>
                                <div class="map-top-text">
                                    <span>Location</span>
                                    <p>125 Brooklin, Huston, USA</p>
                                </div>
                            </div>
                            <div class="map-top-block">
                                <div class="map-inner-ic">
                                    <i class="icofont icofont-smart-phone"></i>
                                </div>
                                <div class="map-top-text">
                                    <span>Call us</span>
                                    <p>+91 123 456 7890</p>
                                </div>
                            </div>
                            <div class="map-top-block">
                                <div class="map-inner-ic">
                                    <i class="icofont icofont-envelope-open"></i>
                                </div>
                                <div class="map-top-text">
                                    <span>Email Us</span>
                                    <p><a href="mailto:youremailid@gmail.com" title="youremailid@gmail.com">youremailid@gmail.com</a></p>
                                </div>
                            </div>
                            <div class="map-top-block">
                                <div class="map-inner-ic">
                                    <i class="icofont icofont-clock-time"></i>
                                </div>
                                <div class="map-top-text">
                                    <span>Hours</span>
                                    <p>Mon to Sat: 9AM to 7PM</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div class="map-img">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48331.30547831374!2d-74.05590848053964!3d40.79046415662649!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25804d4293b57%3A0x5efe2629bb9f9381!2sNorth+Bergen%2C+NJ%2C+USA!5e0!3m2!1sen!2sin!4v1503222998458" frameborder="0" allowfullscreen></iframe>
            </div>
        </>
    )
}

export default Contact
